import Vue from 'vue'
import App from './App.vue'
import router from '@/shared/router'
import store from '@/shared/store'
import axios from '@/shared/api/http'

// 引人Element框架
import Element from 'element-ui'

// 阿里伸缩布局方案
import 'amfe-flexible'
// 引入公共样式
import '@/shared/styles/base.styl'
import 'element-ui/lib/theme-chalk/index.css'

import components from '@/shared/components'

// 注册全局组件
Vue.use(Element)
Vue.use(components)
Vue.prototype.axios = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
